import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GmDashboardService } from '../gm-dashboard.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-addcameradialog',
  templateUrl: './addcameradialog.component.html',
  styleUrls: ['./addcameradialog.component.scss']
})
export class AddcameradialogComponent {
  
  channelfrom!: FormGroup;
  cctvCreds: any;
  cctvFrameURL: any
  cctvURL: any;
  camera: any;
  buildname: any
  result: Object;


  constructor(public campuscctvserviceservice: GmDashboardService, @Inject(MAT_DIALOG_DATA) public data: any, private toast: ToastmessageService, private domSanitizer: DomSanitizer, private fb: FormBuilder, public dialogRef1: MatDialogRef<AddcameradialogComponent>) { }
  ngOnInit(): void {
    console.log("addcctv", this.data);

    this.camera = this.data.camera;
    this.buildname = this.data.buildingName,
      // channelNo
      this.campuscctvserviceservice.getChannel(this.camera.cctvDetId, this.camera.channelNo).subscribe((res) => {
        this.cctvCreds = res;
        console.log('cctvdetails', this.cctvCreds);
        // const URL = `https://cctvstream.scaits.net/CCTVIndex?cctvDetId=${this.cctvCreds[0].cctvDetId}&buildingId=${this.cctvCreds[0].buildingId}&ipAddress=${this.cctvCreds[0].ipAddress}&userName=${this.cctvCreds[0].userName}&pwd=${this.cctvCreds[0].password}&httpPortNo=${this.cctvCreds[0].rtspPortNo}&cctvChannelNo=${this.cctvCreds[0].channelsNo}&rtspPortNo=${this.cctvCreds[0].rtspPortNo}`
        const URL = `https://cctvstream.scaits.net/buildingCctvFrame?buildingId=${this.cctvCreds[0].buildingId}&dvrIPAddress=${this.cctvCreds[0].ipAddress}&userName=${this.cctvCreds[0].userName}&pwd=${this.cctvCreds[0].password}&portNo=${this.cctvCreds[0].rtspPortNo}&cctvChannelNo=${this.cctvCreds[0].channelsNo}`

        // ${this.cctvCreds[0].cctvStreamingBaseUrl}/
        this.cctvURL = this.domSanitizer.bypassSecurityTrustResourceUrl(URL);
        // this.spinner.hide();
      });
    this.channelfrom = this.fb.group({
      Channelname: ["", Validators.required]
    })
  }
  save() {
    if (this.channelfrom.valid) {
      let data = {
        "payRollId": this.data.empDetails.payrollId,
        "empId": this.data.empDetails.empId,
        "empName": this.data.empDetails.empName,
        "designation": this.data.empDetails.designation,
        "dvrDetails": {
          "dvrName": this.buildname,
          "cctvDetId": this.camera.cctvDetId,
          "cameras": [
            {
              "channelNo": this.camera.channelNo,
              "channelName": this.channelfrom.value.Channelname
            }
          ]
        }
      }
      if (confirm("Do you want to save the Video Camera")) {
        this.campuscctvserviceservice.getsavecammera(data).subscribe({
          next: (res: any) => {
            this.result = res;
            this.dialogRef1.close();
            console.log(this.result);
          },
          error: (err: any) => {
            if (err.status === 404) {
              this.toast.showWarning("The video camera has already been Added");
            }
          }
        });

      }
    } else {
      this.toast.showError("Please Enter the ChannelName")
    }


  }
  saveCamera() {
    // Your logic to save the video
    this.dialogRef1.close('saved');
  }
}
